module.exports = __webpack_public_path__ + "media/四建欢迎你.8ac9fc10.mp3";